interface V3IconAnalyticsProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: string;
}

export const V3IconAnalytics = ({ stroke = "#ABB0BA", size = "24", ...rest }: V3IconAnalyticsProps) => (
    <svg width={size} height={size} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="13.2" width="3.6" height="7.2" rx=".6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="17.4" y="8.4" width="3.6" height="12" rx=".6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="10.2" y="3.6" width="3.6" height="16.8" rx=".6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
